import store from '@/store'

export default [
  {
    path: '/employee-profiles',
    name: 'employee-profile',
    meta: { requireAuth: true },
    component: () => import('@/pages/employee-profile/index.vue')
  },
  {
    path: '/employee-profiles/create',
    name: 'employee-profile-create',
    meta: { requireAuth: true },
    component: () => import('@/pages/employee-profile/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('employeeProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/employee-profiles/:id',
    name: 'employee-profile-edit',
    meta: { requireAuth: true },
    component: () => import('@/pages/employee-profile/edit.vue'),
    props: route => ({ employeeProfile: route.params.employeeProfile }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('employeeProfile/dataBeforeCreate')
      let response = await store.dispatch('employeeProfile/find', to.params.id)
      let { division, department, ...resource } = response.data
      to.params.employeeProfile = resource
      next()
    }
  }
]
